var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showFlatRateWebmail
        ? _c("base-card", { attrs: { overflowVisible: "" } }, [
            _c(
              "div",
              { staticClass: "text-center" },
              [
                _c("h4", {
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("flatRateWebmail.title"))
                  }
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("flatRateWebmail.description", {
                        price: _vm.appointmentPrice,
                        currency: _vm.currency
                      })
                    )
                  }
                }),
                _vm._v(" "),
                !_vm.patientIsMinorNoPet
                  ? _c(
                      "b-row",
                      [
                        !_vm.patientIsCollective
                          ? _c(
                              "b-col",
                              { staticClass: "mb-3", attrs: { cols: "12" } },
                              [
                                _c("h5", {
                                  domProps: {
                                    innerHTML: _vm._s(_vm.$t("forWhoFlatRate"))
                                  }
                                }),
                                _vm._v(" "),
                                _c("base-select", {
                                  attrs: {
                                    options: _vm.forWhoOptions,
                                    label: "name",
                                    valueProp: "value",
                                    placeholder: _vm.$t("forWhoFlatRate")
                                  },
                                  on: { input: _vm.changeSelectUser },
                                  model: {
                                    value: _vm.formData.forWho,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formData, "forWho", $$v)
                                    },
                                    expression: "formData.forWho"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showMinorPatientSelector
                          ? _c(
                              "b-col",
                              { staticClass: "mb-3", attrs: { cols: "12" } },
                              [
                                _c("h5", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("selectPatientForFlatRate") + ":"
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c("base-select", {
                                  attrs: {
                                    options: _vm.associatedPatients.patients,
                                    label: "name",
                                    valueProp: "idPatient",
                                    placeholder: _vm.$t(
                                      "selectPatientForFlatRate"
                                    )
                                  },
                                  on: { input: _vm.onMinorPatientSelected },
                                  model: {
                                    value: _vm.minorPatientId,
                                    callback: function($$v) {
                                      _vm.minorPatientId = $$v
                                    },
                                    expression: "minorPatientId"
                                  }
                                }),
                                _vm._v(" "),
                                _c("small", [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t("patientNotFoundQuestion")
                                      )
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "href",
                                      on: {
                                        click: _vm.showModalRegisterPatient
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("clickHere")))]
                                  )
                                ])
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("flatRateWebmail.disclaimer"))
                  }
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "mt-3",
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("flatRateWebmail.question"))
                  }
                }),
                _vm._v(" "),
                _c(
                  "b-row",
                  { staticClass: "mt-5" },
                  [
                    _c(
                      "b-col",
                      { staticClass: "text-center", attrs: { cols: "12" } },
                      [
                        _c(
                          "base-button",
                          {
                            staticClass: "mr-3",
                            on: { click: _vm.hireFlatRateWebmail }
                          },
                          [_vm._v(_vm._s(_vm.$t("yes")))]
                        ),
                        _c(
                          "base-button",
                          {
                            attrs: { red: "" },
                            on: {
                              click: function($event) {
                                return _vm.$router.push("/patient")
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("no")))]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        : _vm.showServicesPackagesTable
        ? _c("services-packages-table", {
            attrs: { data: _vm.profServicesPackages },
            on: {
              servicesPackageSelected: function($event) {
                return _vm.goToServicesPackagesPayment($event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "base-card",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showAppointmentRequestView,
              expression: "showAppointmentRequestView"
            }
          ],
          attrs: { overflowVisible: "" }
        },
        [
          _c("div", { staticClass: "mb-3" }, [
            _c("h4", {
              domProps: { innerHTML: _vm._s(_vm.$t("appointmentSummary")) }
            }),
            _vm._v(" "),
            _vm.needsSchedule
              ? _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("date") + ": " + _vm.appointmentDateFormatted)
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.needsSchedule
              ? _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("hour") + ": " + _vm.appointmentHourFormatted)
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.multiRatesSelected.description
              ? _c("div", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("description") +
                        ": " +
                        _vm.multiRatesSelected.description
                    )
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                _vm._s(
                  _vm.$t("price") +
                    ": " +
                    _vm.appointmentPrice +
                    " " +
                    _vm.currency
                )
              )
            ]),
            _vm._v(" "),
            _vm.centerId
              ? _c("div", [
                  _vm._v(_vm._s(_vm.$t("center") + ": " + _vm.centerInfo.name))
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.centerId
            ? _c(
                "base-button",
                {
                  staticClass: "mb-3",
                  attrs: { white: "" },
                  on: {
                    click: function($event) {
                      _vm.showCenterDetails = !_vm.showCenterDetails
                    }
                  }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.showCenterDetails
                        ? _vm.$t("hideCenterDetails")
                        : _vm.$t("showCenterDetails")
                    )
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showCenterDetails
            ? _c("div", { staticClass: "mb-3" }, [
                _c("img", {
                  staticClass: "center-photo mb-3",
                  attrs: { alt: "center", src: _vm.centerInfo.photo }
                }),
                _vm._v(" "),
                _c("h4", {
                  staticStyle: { display: "inline-block" },
                  domProps: { innerHTML: _vm._s(_vm.centerInfo.name) }
                }),
                _vm._v(" "),
                _vm.centerInfo.address
                  ? _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("address") + ": " + _vm.centerInfo.address
                        )
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.centerInfo.schedule
                  ? _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("schedule") + ": " + _vm.centerInfo.schedule
                        )
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.centerInfo.phone
                  ? _c("div", [
                      _vm._v(
                        _vm._s(_vm.$t("phone") + ": " + _vm.centerInfo.phone)
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.centerInfo.services
                  ? _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("services") + ": " + _vm.centerInfo.services
                        )
                      )
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isFirstAppointment
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "mb-3", attrs: { cols: "12", md: "5" } },
                    [
                      _c("h4", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("isFirstAppointmentQuestion")
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("base-select", {
                        attrs: {
                          options: _vm.isFirstAppointmentOptions,
                          label: "name",
                          valueProp: "value",
                          placeholder: _vm.$t(
                            "selectForisFirstAppointmentQuestion"
                          )
                        },
                        on: { input: _vm.isFirstAppointmentSelected },
                        model: {
                          value: _vm.formData.isFirstAppointment,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "isFirstAppointment", $$v)
                          },
                          expression: "formData.isFirstAppointment"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.patientIsMinorNoPet
            ? _c(
                "b-row",
                { staticClass: "col-gap" },
                [
                  !_vm.patientIsCollective
                    ? _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", md: "5" } },
                        [
                          _c("h4", {
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("forWhoQuestion"))
                            }
                          }),
                          _vm._v(" "),
                          _c("base-select", {
                            attrs: {
                              options: _vm.forWhoOptions,
                              label: "name",
                              valueProp: "value",
                              placeholder: _vm.$t("selectforWhoQuestion")
                            },
                            on: { input: _vm.changeSelectUser },
                            model: {
                              value: _vm.formData.forWho,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "forWho", $$v)
                              },
                              expression: "formData.forWho"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showMinorPatientSelector
                    ? _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", md: "5" } },
                        [
                          _c("h4", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("selectPatientForConsultation") + ":"
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("base-select", {
                            attrs: {
                              options: _vm.associatedPatients.patients,
                              label: "name",
                              valueProp: "idPatient",
                              placeholder: _vm.$t(
                                "selectPatientForConsultation"
                              )
                            },
                            on: { input: _vm.onMinorPatientSelected },
                            model: {
                              value: _vm.minorPatientId,
                              callback: function($$v) {
                                _vm.minorPatientId = $$v
                              },
                              expression: "minorPatientId"
                            }
                          }),
                          _vm._v(" "),
                          _c("small", [
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("patientNotFoundQuestion")
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "href",
                                on: { click: _vm.showModalRegisterPatient }
                              },
                              [_vm._v(_vm._s(_vm.$t("clickHere")))]
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showPetSelector
                    ? _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", md: "5" } },
                        [
                          _c("h4", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("selectPetForConsultation") + ":"
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("base-select", {
                            attrs: {
                              options: _vm.associatedPatients.patients,
                              label: "name",
                              valueProp: "idAnimal",
                              placeholder: _vm.$t("selectPetForConsultation")
                            },
                            model: {
                              value: _vm.formData.pet,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "pet", $$v)
                              },
                              expression: "formData.pet"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.patientIsCollective
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "mb-3", attrs: { cols: "12", md: "5" } },
                    [
                      _c("h4", {
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("nameAuthorizedMinor"))
                        }
                      }),
                      _vm._v(" "),
                      _c("base-input", {
                        attrs: {
                          placeholder: _vm.$t("nameAuthorizedMinorPlaceholder")
                        },
                        model: {
                          value: _vm.formData.nameAuthorizedForMinor,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.formData,
                              "nameAuthorizedForMinor",
                              $$v
                            )
                          },
                          expression: "formData.nameAuthorizedForMinor"
                        }
                      }),
                      _vm._v(" "),
                      _c("small", [
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(_vm.$t("nameAuthorizedMinorInfo"))
                          }
                        })
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showInsurancesRequest
            ? _c(
                "b-row",
                { staticClass: "col-gap" },
                [
                  _c(
                    "b-col",
                    { staticClass: "mb-3", attrs: { cols: "12", md: "5" } },
                    [
                      _c("h4", {
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("insuranceornot"))
                        }
                      }),
                      _vm._v(" "),
                      _c("base-select", {
                        attrs: {
                          options: _vm.haveInsurance.options,
                          label: "name",
                          valueProp: "value",
                          placeholder: _vm.$t("insuranceornot")
                        },
                        model: {
                          value: _vm.haveInsurance.value,
                          callback: function($$v) {
                            _vm.$set(_vm.haveInsurance, "value", $$v)
                          },
                          expression: "haveInsurance.value"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showInsurancesOptions
                    ? _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", md: "5" } },
                        [
                          _c("h4", {
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("selectAnInsurer") + ":")
                            }
                          }),
                          _vm._v(" "),
                          _c("base-select", {
                            attrs: {
                              options: _vm.profInsurers,
                              label: "name",
                              valueProp: "id",
                              placeholder: _vm.$t("selectAnInsurer")
                            },
                            on: {
                              input: function($event) {
                                _vm.showInsuranceForm = true
                              }
                            },
                            model: {
                              value: _vm.formData.insurance,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "insurance", $$v)
                              },
                              expression: "formData.insurance"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showInsuranceForm
            ? _c(
                "b-row",
                { staticClass: "col-gap" },
                [
                  _c(
                    "b-col",
                    { staticClass: "mb-3", attrs: { cols: "12" } },
                    [
                      _c("h4", {
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("insuranceCardDetails"))
                        }
                      }),
                      _vm._v(" "),
                      _c("base-input", {
                        staticClass: "mb-3",
                        attrs: { placeholder: _vm.$t("insurancecardnumber") },
                        model: {
                          value: _vm.formData.insuranceCardData.number,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.formData.insuranceCardData,
                              "number",
                              $$v
                            )
                          },
                          expression: "formData.insuranceCardData.number"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "mb-3", attrs: { cols: "12", md: "3" } },
                    [
                      _c("base-select", {
                        attrs: {
                          options: _vm.months,
                          label: "name",
                          valueProp: "value",
                          placeholder: _vm.$t("month")
                        },
                        model: {
                          value: _vm.formData.insuranceCardData.month,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.formData.insuranceCardData,
                              "month",
                              $$v
                            )
                          },
                          expression: "formData.insuranceCardData.month"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "mb-3", attrs: { cols: "12", md: "3" } },
                    [
                      _c("base-select", {
                        attrs: {
                          options: _vm.years,
                          label: "name",
                          valueProp: "value",
                          placeholder: _vm.$t("year")
                        },
                        model: {
                          value: _vm.formData.insuranceCardData.year,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.formData.insuranceCardData,
                              "year",
                              $$v
                            )
                          },
                          expression: "formData.insuranceCardData.year"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "mb-3", attrs: { cols: "12" } },
                    [
                      _c("base-input", {
                        attrs: {
                          placeholder: _vm.$t("insurancecardHolderName")
                        },
                        model: {
                          value: _vm.formData.insuranceCardData.holderName,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.formData.insuranceCardData,
                              "holderName",
                              $$v
                            )
                          },
                          expression: "formData.insuranceCardData.holderName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showCallInfo
            ? _c(
                "b-row",
                { staticClass: "col-gap" },
                [
                  _c(
                    "b-col",
                    { staticClass: "mb-3", attrs: { cols: "12", md: "5" } },
                    [
                      _c("h4", {
                        domProps: { innerHTML: _vm._s(_vm.$t("prefix")) }
                      }),
                      _vm._v(" "),
                      _c("base-select", {
                        attrs: {
                          clearable: "",
                          searchable: "",
                          placeholder: _vm.$t("prefix"),
                          options: _vm.phonePrefixOptions,
                          label: _vm.$i18nHelpers.normalizeProp(
                            "prefixAndCountry"
                          ),
                          valueProp: "idCountry"
                        },
                        model: {
                          value: _vm.formData.callInfo.prefix,
                          callback: function($$v) {
                            _vm.$set(_vm.formData.callInfo, "prefix", $$v)
                          },
                          expression: "formData.callInfo.prefix"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "mb-3", attrs: { cols: "12", md: "5" } },
                    [
                      _c("h4", {
                        domProps: { innerHTML: _vm._s(_vm.$t("phoneShort")) }
                      }),
                      _vm._v(" "),
                      _c("base-input", {
                        attrs: { placeholder: _vm.$t("phone") },
                        model: {
                          value: _vm.formData.callInfo.phone,
                          callback: function($$v) {
                            _vm.$set(_vm.formData.callInfo, "phone", $$v)
                          },
                          expression: "formData.callInfo.phone"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "col-gap" },
            [
              _c(
                "b-col",
                { staticClass: "mb-3", attrs: { cols: "12", md: "5" } },
                [
                  _c("h4", {
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("selectDisease") + ":")
                    }
                  }),
                  _vm._v(" "),
                  _c("base-select", {
                    attrs: {
                      clearable: "",
                      loading: _vm.disease.loading,
                      searchable: "",
                      options: _vm.disease.options,
                      avoidDefaultSort: "",
                      label: _vm.$i18nHelpers.normalizeProp("name"),
                      valueProp: "id",
                      placeholder: _vm.$t("selectDisease")
                    },
                    on: {
                      search: function($event) {
                        return _vm.loadDiseases({ search: $event })
                      },
                      input: _vm.onDiseaseSelected
                    },
                    model: {
                      value: _vm.formData.disease.id,
                      callback: function($$v) {
                        _vm.$set(_vm.formData.disease, "id", $$v)
                      },
                      expression: "formData.disease.id"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "mb-3", attrs: { cols: "12" } },
                [
                  _c("h4", {
                    domProps: { innerHTML: _vm._s(_vm.$t("reasonTitle")) }
                  }),
                  _vm._v(" "),
                  _c("content-editable", {
                    attrs: { placeholder: _vm.$t("reasonPlaceholder") },
                    model: {
                      value: _vm.formData.reason,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "reason", $$v)
                      },
                      expression: "formData.reason"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "mb-3", attrs: { cols: "12" } },
                [
                  _c(
                    "base-checkbox",
                    {
                      model: {
                        value: _vm.formData.shareClinicHistory,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "shareClinicHistory", $$v)
                        },
                        expression: "formData.shareClinicHistory"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("shareClinicHistory")))]
                  ),
                  _vm._v(" "),
                  !_vm.formData.shareClinicHistory
                    ? _c("span", {
                        staticStyle: { "font-weight": "bold" },
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("noSharedClinicHistoryAdvice")
                          )
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "mb-3", attrs: { cols: "12" } },
                [
                  _c(
                    "base-checkbox",
                    {
                      model: {
                        value: _vm.formData.shareClinicHistoryWithCenters,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.formData,
                            "shareClinicHistoryWithCenters",
                            $$v
                          )
                        },
                        expression: "formData.shareClinicHistoryWithCenters"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("shareClinicHistoryWithCenters")))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.showDocumentsUploader
                ? _c(
                    "b-col",
                    { staticClass: "mb-3", attrs: { cols: "12", md: "5" } },
                    [
                      _c("upload-file-group-form", {
                        model: {
                          value: _vm.formData.localFiles,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "localFiles", $$v)
                          },
                          expression: "formData.localFiles"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isMedicalSpecialty
                ? _c(
                    "b-col",
                    { staticClass: "mb-3", attrs: { cols: "12" } },
                    [
                      _c(
                        "base-checkbox",
                        {
                          model: {
                            value: _vm.formData.foreignPatient,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "foreignPatient", $$v)
                            },
                            expression: "formData.foreignPatient"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("englishPrescription")))]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "base-checkbox",
                    {
                      staticClass: "mb-3",
                      model: {
                        value: _vm.formData.termsAccepted,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "termsAccepted", $$v)
                        },
                        expression: "formData.termsAccepted"
                      }
                    },
                    [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("signupOH.accept-terms-patient")
                          )
                        }
                      })
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-5" },
            [
              _c(
                "b-col",
                { staticClass: "text-center", attrs: { cols: "12" } },
                [
                  _c("back-button", {
                    staticClass: "mr-3",
                    attrs: { withoutArrow: "" }
                  }),
                  _vm._v(" "),
                  _c(
                    "base-button",
                    {
                      attrs: { disabled: _vm.continueBtnDisabled },
                      on: { click: _vm.remindHealthData }
                    },
                    [_vm._v(_vm._s(_vm.$t("continue")))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("base-dialog", {
            attrs: {
              content: _vm.modal.content,
              okBtnText: _vm.modal.okBtnText,
              okFn: _vm.modal.okFn,
              cancelBtnText: _vm.modal.cancelBtnText,
              cancelFn: _vm.modal.cancelFn,
              closable: false
            },
            on: { hidden: _vm.onModalHidden },
            model: {
              value: _vm.modal.show,
              callback: function($$v) {
                _vm.$set(_vm.modal, "show", $$v)
              },
              expression: "modal.show"
            }
          }),
          _vm._v(" "),
          _c("tarifa-plus-disabled-modal", {
            attrs: { userId: _vm.profId, isProfUser: "" },
            model: {
              value: _vm.showTarifaPlusDisabledModal,
              callback: function($$v) {
                _vm.showTarifaPlusDisabledModal = $$v
              },
              expression: "showTarifaPlusDisabledModal"
            }
          }),
          _vm._v(" "),
          _c("video-test-modal", {
            attrs: { fromAppointmentRequest: "" },
            on: {
              resultTest: function($event) {
                return _vm.checkVideoTestResult($event)
              }
            },
            model: {
              value: _vm.showVideoTestModal,
              callback: function($$v) {
                _vm.showVideoTestModal = $$v
              },
              expression: "showVideoTestModal"
            }
          }),
          _vm._v(" "),
          _c(
            "base-modal",
            {
              attrs: {
                noCloseOnBackdrop: "",
                noCloseOnScape: "",
                hideClose: "",
                title: _vm.$t("flatRateWebmail.title")
              },
              model: {
                value: _vm.showFlatRateWebmailSelectorModal,
                callback: function($$v) {
                  _vm.showFlatRateWebmailSelectorModal = $$v
                },
                expression: "showFlatRateWebmailSelectorModal"
              }
            },
            [
              _c(
                "div",
                { class: { "text-center": !_vm.$uiHelpers.isMobile } },
                [
                  _c("h5", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("flatRateWebmailSelector.question")
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c("base-radio-group", {
                    attrs: {
                      stacked: _vm.$uiHelpers.isMobile,
                      options: _vm.flatRateWebmailSelector.options
                    },
                    model: {
                      value: _vm.flatRateWebmailSelector.value,
                      callback: function($$v) {
                        _vm.$set(_vm.flatRateWebmailSelector, "value", $$v)
                      },
                      expression: "flatRateWebmailSelector.value"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-5" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-center", attrs: { cols: "12" } },
                        [
                          _c(
                            "base-button",
                            { on: { click: _vm.flatRateWebmailSelected } },
                            [_vm._v(_vm._s(_vm.$t("continue")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-380a2bcc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-380a2bcc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/webapp/patient/appointment-request/AppointmentRequestInit.vue
// module id = 4133
// module chunks = 2